import { createContext } from "react";

export const AccountState = createContext();
AccountState.displayName = "AccountState";
